import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export default function PageBanner({ title, subtitle, crumb, image }) {
  return (
    <section className="relative overflow-hidden bg-[#0f2340]">
      {image && (
        <img src={image} alt={title} className="absolute inset-0 w-full h-full object-cover opacity-40" />
      )}
      <div className="absolute inset-0 bg-gradient-to-r from-[#0f2340] via-[#0f2340]/90 to-[#132b4d]/60" />
      <div className="eig-blob w-[420px] h-[420px] bg-[#1ca5dc]/30 -top-24 right-10" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 w-full pt-20 pb-16 md:pt-24 md:pb-20">
        <div className="max-w-2xl">
          <div className="flex items-center gap-2 mb-5 text-sm text-slate-300">
            <Link to="/" className="hover:text-[#5cc6ef] transition-colors">Home</Link>
            <ChevronRight size={15} />
            <span className="text-[#5cc6ef] font-semibold">{crumb || title}</span>
          </div>
          <h1 className="text-white font-heading font-extrabold text-4xl md:text-6xl leading-[1.05]">{title}</h1>
          {subtitle && <p className="text-slate-300 mt-5 text-lg leading-relaxed max-w-xl">{subtitle}</p>}
        </div>
      </div>
    </section>
  );
}
